import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import LaptopIcon from '@mui/icons-material/Laptop';

export const BASE_URL = "https://api.coincap.io/v2/assets"
export const FACEBOOK_LINK = "https://www.facebook.com/coincapmarketdata/videos/365220420785166/"
export const TWITTER_LINK = "https://twitter.com/CoinCap_io"
export const GOOGLE_PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=io.coinCap.coinCap"
export const APPLE_PLAY_STORE_LINK = "https://apps.apple.com/us/app/coincap/id1074052280?ign-mpt=uo%3D4"

export const SMALL_DEVICE_WIDTH = 825;

export const ICONS = {
    ArrowForwardIcon,
    CurrencyBitcoinIcon,
    SearchIcon,
    SettingsIcon,
    ArrowDropDownIcon,
    MenuIcon,
    CloseIcon,
    SyncAltIcon,
    SwapHorizontalCircleIcon,
    LaptopIcon
}